import {
  DOCX_RENDERER_IDS,
  docxComponentDefinitionName
} from "./chunk-63KVFQ5V.js";

// src/schemas/block-authoring.ts
import {
  createBlockAuthoringSchema
} from "@json-to-office/shared";
function addDocxBlockAuthoringSchemas(schema) {
  const definitions = schema.definitions ?? {};
  const bodies = /* @__PURE__ */ new Map();
  for (const renderer of DOCX_RENDERER_IDS) {
    const name = docxComponentDefinitionName(renderer);
    if (definitions[name])
      bodies.set(
        renderer,
        createBlockAuthoringSchema(definitions, name, ["docx", "section"])
      );
  }
  const visit = (node) => {
    if (!node || typeof node !== "object") return;
    if (Array.isArray(node)) {
      node.forEach(visit);
      return;
    }
    const value = node;
    if (value.properties?.name?.const === "docx") {
      const body = bodies.get(value.properties.renderer?.const);
      const blocks = value.properties.props?.properties?.blocks?.patternProperties;
      if (body && blocks)
        for (const block of Object.values(blocks)) {
          block.properties.body.items = body;
          for (const part of ["header", "footer"])
            block.properties.section.properties[part].items = body;
        }
    }
    Object.values(value).forEach(visit);
  };
  visit(schema);
}
function docxDocumentBlockTargets(schema) {
  const definitions = schema.definitions ?? {};
  return DOCX_RENDERER_IDS.filter(
    (renderer) => definitions[docxComponentDefinitionName(renderer)]
  ).map((renderer) => {
    const name = docxComponentDefinitionName(renderer);
    return { name, componentRef: { $ref: `#/definitions/${name}` } };
  });
}

export {
  addDocxBlockAuthoringSchemas,
  docxDocumentBlockTargets
};
//# sourceMappingURL=chunk-A47SR2YB.js.map